module.exports = __webpack_public_path__ + "img/pinren1.10a99607.jpg";